import React from 'react'
import { StyledTextAreaForm, Props } from './styled'

export const TextAreaForm: React.FC<Props> = (props: Props) => {
  return <StyledTextAreaForm {...props} />
}
